import AddExamsList from './AddExamsList';

export default AddExamsList;
